import type { NCNode } from '../../../../src/commonTypes';

/**
 * A tool panel belongs to the node that opened it. Keep that explicit source
 * stable even if Flowy or another interaction focuses a different node while
 * the panel remains open.
 */
export const getNewNodeLinkTargets = (
	sourceNode: NCNode,
	additionalNodes: NCNode[] = []
): NCNode[] => {
	const seen = new Set<string>();
	return [sourceNode, ...additionalNodes].filter((node) => {
		if (seen.has(node.uid)) return false;
		seen.add(node.uid);
		return true;
	});
};
